import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingPhotoRestorationConfig } from '@/data/landingConfig/landingPhotoRestorationConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_PhotoRestoration } from './schemaObject';

const PhotoRestoration = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_PhotoRestoration} />
			<LandingTemplate
				data={landingPhotoRestorationConfig}
				funnelLinkService={GenerateLandingLinkService.funnelPhotoColorizer()}
			/>
		</>
	);
};

export default PhotoRestoration;
